import { z } from 'zod';
export const StopTranscriptionQueryRequestSchema = z.object({
    m: z.string(),
});
export const StopTranscriptionRequestSchema = StopTranscriptionQueryRequestSchema;
